import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

    }

    trigger(e) {
        
        // data-module-theme="uID" data-scroll data-scroll-repeat data-scroll-call="trigger,Theme, uID" 
        // data-trigger-top="light" data-trigger-bottom="dark"
        let themes = [e.$el.getAttribute('data-trigger-top'), e.$el.getAttribute('data-trigger-bottom')];

        if(e.mode === 'enter' && e.direction == 'down') {
            html.setAttribute('data-theme', themes[1]);
        }
        if(e.mode === 'leave' && e.direction == 'up') {
            html.setAttribute('data-theme', themes[0]);
        }
    }
}
